import { Select } from '@servicecompressionllc/sc-design-system';
import { TemplateInput } from '../controls/TemplateInput.js';
import { DeliverWindowEditor } from '../DeliverWindowEditor.js';
import type { StepEditorProps } from './types.js';

export const NotificationStepEditor = ({
  step,
  ctx,
  vars,
  onChange: put,
}: StepEditorProps<'notify'>) => {
  return (
    <>
      <label className="grid min-w-0 gap-1 text-xs text-ink-muted">
        Who should get this?
        <Select
          aria-label="Who should get this?"
          multiple
          options={ctx.destinationOptions}
          value={[
            ...step.channelIds,
            ...(step.recipients ?? []).map((recipient) => `${recipient.kind}:${recipient.id}`),
          ]}
          placeholder="Pick people"
          onChange={(channelIds) => put({ ...step, channelIds, recipients: [] })}
        />
      </label>
      <TemplateInput
        label="Title"
        value={step.title}
        vars={vars}
        source={ctx.eventSource}
        onChange={(v) => put({ ...step, title: v })}
      />
      <TemplateInput
        label="Body"
        value={step.body}
        vars={vars}
        source={ctx.eventSource}
        multiline
        onChange={(v) => put({ ...step, body: v })}
      />
      <div className="flex items-end gap-6">
        <label className="grid min-w-0 max-w-[50%] flex-1 gap-1 text-xs text-ink-muted">
          Severity
          <Select
            aria-label="Severity"
            options={[
              { value: 'info', label: 'Info' },
              { value: 'warning', label: 'Warning' },
              { value: 'critical', label: 'Critical' },
            ]}
            value={[step.severity ?? 'info']}
            searchable={false}
            onChange={(picked) =>
              put({
                ...step,
                severity: (picked[0] ?? 'info') as 'info' | 'warning' | 'critical',
              })
            }
          />
        </label>
      </div>
      <p className="text-xs text-ink-subtle">
        Pick a person and their direct message is set up when you save. Channels come from the
        Notifications screen.
      </p>
      <DeliverWindowEditor
        value={step.deliverWindow}
        onChange={(deliverWindow) => put({ ...step, deliverWindow })}
      />
    </>
  );
};
